/**
 * Questo file contiene la definizione delle variabili d'ambiente per ogni servizio.
 * La struttura è la seguente:
 * nomeLauncher: {
 *  nomeVariabile: [valore1, valore2, ..., valoreN]
 * }
 *
 * Se nel valore è presente null, significa che la variabile d'ambiente non è obbligatoria.
 * Il primo valore è quello di default.
 */

const CHROME = ['adspower-rebrowser', 'adspower', 'adspower-xvfb', 'rebrowser', null]
const FINGERPRINT = ['native', 'fingerprint1', 'fingerprint2', null]
const PROXY = ['no', 'local', 'teddy', 'tunnel', 'byteproxy', '2captcha', null]

const envIntegrity = {
  eventimScanner: {
    PLATFORM: ['eventim'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY,
    BLOCK_RESOURCE: ['yes', 'no', null]
  },
  fansaleScanner: {
    PLATFORM: ['fansale'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY,
    BLOCK_RESOURCE: ['yes', 'no', null],
    SCAN_MODE: ['fetch', 'click', null],
    SKIP_AUTOSCROLL: ['no', 'yes', null]
  },
  hyperFansaleScanner: {
    PLATFORM: ['fansale'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    PROXY: ['2captcha', 'local', 'tunnel', null]
  },
  fansaleEventScanner: {
    PLATFORM: ['fansaleEvent'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY,
    BLOCK_RESOURCE: ['no', 'yes', null]
  },
  ticketmasterScanner: {
    PLATFORM: ['ticketmaster'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY
  },
  vivaticketScanner: {
    PLATFORM: ['vivaticket'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY,
    BLOCK_RESOURCE: ['no', 'yes', null]
  },
  vivaresaleScanner: {
    PLATFORM: ['vivaresale'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME
  },
  ticketooScanner: {
    PLATFORM: ['ticketoo'],
    ROLE: ['scanner'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    PROXY,
    BLOCK_RESOURCE: ['yes', 'no', null]
  },
  fansaleCarter: {
    PLATFORM: ['fansale'],
    ROLE: ['carter'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    CART_TYPE: ['evaluate', 'interceptor'],
    RESTART: ['yes', 'no'],
    FINGERPRINT,
    CHROME,
    PROXY,
    TELEGRAM_BOT: ['default', 'cart1', 'cart2', 'cart3', 'cart4', 'cart5', 'cart6', 'cart7', 'cart8', 'phone'],
    TELEGRAM_THREAD: ['General', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'L', 'M']
  },
  ticketmasterCarter: {
    PLATFORM: ['ticketmaster'],
    ROLE: ['carter'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME
  },
  eventimCarter: {
    PLATFORM: ['eventim'],
    ROLE: ['carter'],
    COUNTRY: ['it'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME
  },
  gigsberg: {
    PLATFORM: ['gigsberg'],
    ROLE: ['scanner'],
    HEADLESS: ['visible', 'headless'],
    FINGERPRINT,
    CHROME,
    BLOCK_RESOURCE: ['no', 'yes', null],
    // 'browser' = scraping via AdsPower (storico), 'api' = Seller API senza browser,
    // 'shadow' = browser che scrive + API che ricalcola e confronta senza scrivere.
    // Vedi doc/GIGSBERG-API-PLAN.md. Il primo valore è il default.
    GIGSBERG_SCANNER: ['browser', 'api', 'shadow']
  },
  viagogo: {
    PLATFORM: ['viagogo'],
    ROLE: ['scanner'],
    HEADLESS: ['visible', 'headless'],
    WEBSITE: ['inventory', 'viagogo'],
    FINGERPRINT,
    CHROME,
    PROXY: [null, 'local', 'tunnel', '2captcha'],
    BLOCK_RESOURCE: ['no', 'yes', null]
  },
  api: {},
  watchdog: {
    ROLE: ['watchdog'],
    NETNS_CONTROLLER: ['no', 'yes'],
    DEAD_NOTIFY: ['no', 'yes'],
    CLEANER: ['yes', 'no'],
    // Low-cost SMS-only fleet: no more 5G subscriptions → no WiFi→5G forcing
    WIFI_RECOVERY: ['no', 'yes']
  },
  eventimBuyer: {
    PLATFORM: ['eventim'],
    ROLE: ['buyer'],
    COUNTRY: ['it'],
    FINGERPRINT,
    CHROME,
    DRY_RUN: ['no', 'yes'],
    LLM_FALLBACK: ['no', 'yes'],
    BUYER_VERBOSE: ['no', 'yes']
  },
  ticketmasterBuyer: {
    PLATFORM: ['ticketmaster'],
    ROLE: ['buyer'],
    COUNTRY: ['it'],
    FINGERPRINT,
    CHROME
  },
  automatch: {
    ROLE: ['automatch']
  },
  nominativi: {
    ROLE: ['nominativi']
  },
  accounting: {
    ROLE: ['accounting'],
    ACCOUNTING_PROFILE: ['legacy', 'new']
  },
  automate: {
    ROLE: ['automate']
  },
  proxy: {
    ROLE: ['proxy']
  },
  ciroBridge: {
    ROLE: ['bridge'],
    TELEGRAM_BOT: ['default', 'cart1', 'cart2', 'cart3', 'cart4', 'cart5', 'cart6', 'cart7', 'cart8'],
    TELEGRAM_THREAD: ['General', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'L', 'M']
  }
}

module.exports = { envIntegrity }
